import { ContractTenant } from '../../../../common/validations'

export const isChildTenant = (tenant: ContractTenant) =>
  'isAdult' in tenant && !tenant.isAdult
